import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: 'auth-user-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.sass']
})
export class NotAuthorizedComponent implements OnInit {

  targetUrl?: string

  constructor(
    readonly activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    const snapshot = this.activatedRoute.snapshot
    this.targetUrl = snapshot.queryParams['targetUrl']
      ? decodeURIComponent(snapshot.queryParams['targetUrl'])
      : undefined
  }

}
